import { Action, ButtonV2, CopyButton } from '@hg/stylizator/components'
import { TResponsiveValue } from '@hg/stylizator/hooks'
import { media } from '@hg/stylizator/utils'
import * as React from 'react'
import styled from 'styled-components'

import { IActionCouponProps } from '.'

const ActionCoupon = ({
  couponSublabel,
  couponCode,
  afterCopyText,
  couponButtonClassName,
  couponRightButtonTitle,
  couponRightButtonLink,
  actionButtonClassName,
  align,
  sublabelColor,
}: IActionCouponProps) => {
  const alignValue: Record<IActionCouponProps['align'], TResponsiveValue<'center' | 'flex-start' | 'flex-end'>> = {
    left: { default: 'flex-start', desktop: 'flex-start', mobile: 'center' },
    center: 'center',
  }

  return (
    <Action
      align={alignValue[align]}
      reverseOnMobile
      sublabel={couponSublabel}
      sublabelColor={sublabelColor}
      leftButton={
        couponCode ? (
          <ButtonContainer>
            <CopyButton
              copyText={afterCopyText}
              variant="copy"
              buttonProps={{
                icon: 'copy',
                className: couponButtonClassName,
              }}
            >
              {couponCode}
            </CopyButton>
          </ButtonContainer>
        ) : null
      }
      rightButton={
        couponRightButtonTitle ? (
          <ButtonContainer>
            <ButtonV2
              as="a"
              variant="primary"
              color="primary"
              size="medium"
              href={couponRightButtonLink}
              className={actionButtonClassName}
            >
              {couponRightButtonTitle}
            </ButtonV2>
          </ButtonContainer>
        ) : null
      }
    />
  )
}

const ButtonContainer = styled.div`
  width: auto;
  & > * {
    min-width: 200px;
  }

  @media ${media.mobile} {
    width: 100%;
  }
`

export default ActionCoupon
